var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('top-bar'),_c('side-bar'),_c('bread-crumb',{attrs:{"breadcrumbList":_vm.breadcrumbList}}),_c('router-view',{staticClass:"container",on:{"breadcrumbChange":_vm.breadcrumbChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }